import React, { Component } from 'react'

class ErrorTypo extends Component {

    constructor(props) {
        super(props)
        this.handleCorrect = this.handleCorrect.bind(this)
    }

    handleCorrect() {
        this.props.history.push('/search?keyword='+this.props.correctkeyword+'&sort='+this.props.sort)
        return this.props.refresh()
    }

    render() {
        if(0 < this.props.correctkeyword.length) {
            return (
                <div className="autocorrect">
                    Mungkin maksud Anda adalah: <span onClick={this.handleCorrect}>{this.props.correctkeyword}</span>
                </div>
            )
        } else {
            return ''
        }
    }
}

export default ErrorTypo
